<div class="main-container" *ngIf="!isPreview">
  <mat-sidenav-container autosize>
    <mat-sidenav
      #drawer
      mode="side"
      position="start"
      disableClose="true"
      opened="true"
    >
      <app-navigation></app-navigation>&nbsp;
    </mat-sidenav>
    <mat-sidenav-content style="margin-left: 75px">
      <router-outlet></router-outlet>
    </mat-sidenav-content>
  </mat-sidenav-container>
</div>
<div class="main-container" *ngIf="isPreview">
  <router-outlet></router-outlet>
</div>
